import prepareRoutePatterns from 'rlink-router/prepareRoutePatterns';
import prepareRoutesByView from 'rlink-router/prepareRoutesByView';

export default function _initRouteDefinitions (buildContext) {
  return {
    type: 'INIT_ROUTE_DEFINITIONS',
    payload: {
      routeDefinitions: buildContext.routeDefinitions,
      routePatterns: prepareRoutePatterns(buildContext.routeDefinitions, buildContext.regions, buildContext.locales, buildContext.defaultRegion, buildContext.defaultLocale),
      routesByView: prepareRoutesByView(buildContext.routeDefinitions),
    },
  };
}



// WEBPACK FOOTER //
// ./lib/rlink-router/actions/_initRouteDefinitions.js